import { getApiActionCreator } from 'helpers/actionHelper';
import * as constants from './constants';

// Custom action creator that supports isAppending flag for cursor pagination
export const getGatewayEventsLogAction = (loadingStatus, data, error, isAppending = false) => ({
    type: constants.FETCH_GATEWAY_EVENTS_LOG_SETTINGS,
    loadingStatus,
    data,
    error,
    isAppending
});

export const getGatewayEventsAttachmentAction = getApiActionCreator(
    constants.FETCH_GATEWAY_EVENTS_ATTACHMENT_SETTINGS
);

export const getCheckDownloadLogsLimitAction = getApiActionCreator(
    constants.CHECK_DOWNLOAD_LOGS_LIMIT_SETTINGS
);

export const getDownloadLogsZipAction = getApiActionCreator(
    constants.DOWNLOAD_LOGS_ZIP_SETTINGS
);

export const fetchGatewayEventsLog = (gatewayEventsRequest) => ({
    type: constants.FETCH_GATEWAY_EVENTS_LOG,
    payload: gatewayEventsRequest
});

export const loadMoreGatewayEvents = (gatewayEventsRequest) => ({
    type: constants.LOAD_MORE_GATEWAY_EVENTS,
    payload: gatewayEventsRequest
});

export const fetchGatewayEventsAttachment = (attachmentRequest) => ({
    type: constants.FETCH_GATEWAY_EVENTS_ATTACHMENT,
    payload: attachmentRequest
});

export const checkDownloadLogsLimit = (payload) => ({
    type: constants.CHECK_DOWNLOAD_LOGS_LIMIT,
    payload
});

export const downloadLogsZip = (payload, fileName) => ({
    type: constants.DOWNLOAD_LOGS_ZIP,
    payload,
    fileName
});

export const resetDownloadLogsState = () => ({
    type: constants.RESET_DOWNLOAD_LOGS_STATE
});

export const setFilters = (filters) => (dispatch) => {
    dispatch({
        type: constants.SET_GATEWAY_EVENT_LOG_FILTERS,
        filters
    });
};

export const resetFilters = () => (dispatch) => {
    dispatch({
        type: constants.RESET_GATEWAY_EVENT_LOG_FILTERS
    });
};
